import React from 'react';

const IndustryTechStack = ({ title = "Our Technology", items }) => {
   return (
      <section className="industry-tech pt-90 pb-90">
         <div className="tw-container tw-mx-auto">
            <div className="tw-flex tw-flex-wrap tw--mx-3 mb-40">
               <div className="tw-w-full tw-px-3">
                  <div className="section__title section__title-3 mb-0">
                     <h2>{title}</h2>
                  </div>
               </div>
            </div>
            <div className="tw-flex tw-flex-wrap tw--mx-3">
               {items.map((item, index) => (
                  <div key={index} className="tw-w-1/2 tw-px-3 sm:tw-w-1/3 lg:tw-w-1/6 tw-mb-6">
                     <div className="industry-tech__item">
                        <span className="industry-tech__icon" aria-hidden="true">{item.icon}</span>
                        <h4 className="industry-tech__name">{item.name}</h4>
                        <p className="industry-tech__desc">{item.descriptor}</p>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   );
};

export default IndustryTechStack;
